export const CONSTANTS = {
  PAYMENT_LINK:
    'https://elrincondigital.click/checkouts/cn/hWNARu8SnRsE97S60HDkrqQE/en-ar?_r=AQABpLDlK-LsCH_oaS4273fBcXKL_VpO0etvi37o1_pSCEY',
  META_PIXEL_ID: '1225428543097695',
  IMAGES: {
    MAIN_PRODUCT:
      'https://cdn.magicpatterns.com/uploads/fMMK8QjhUbMewEtE7DHw2q/como_comprar_y_vender_oro.png',
    MAIN_PRODUCT_ALT:
      'https://cdn.magicpatterns.com/uploads/fMMK8QjhUbMewEtE7DHw2q/como_comprar_y_vender_oro.png',
    BONO_1:
      'https://cdn.magicpatterns.com/uploads/sHJzmvXDkkVGSPjZ7x2ACw/como_comprar_y_vender_oro_(1).png',
    BONO_2:
      'https://cdn.magicpatterns.com/uploads/sZMUSAgDnghiMq1m1yQn6F/como_comprar_y_vender_oro_(2).png',
    BONO_3:
      'https://cdn.magicpatterns.com/uploads/9FProKjvRHjQWYoAs7KQxS/como_comprar_y_vender_oro_(3).png',
  },
  PRICES: {
    ORIGINAL: '49.900',
    SALE: '19.900',
    DISCOUNT: '-60%',
    ITEMS: {
      MAIN: '89.900',
      CAP_1_2: '29.900',
      CAP_3: '19.900',
      CAP_4_5: '34.900',
      CAP_6_8: '24.900',
      BONO_1: '29.900',
      BONO_2: '24.900',
      BONO_3: '14.900',
      TOTAL_VALUE: '269.200',
    },
  },
}
